import React from 'react';

interface TitleBoxProps {
    icon?: any;
    title: string;
    rightContent?: any;
    children?: any;
}

export function TitleBox(props: TitleBoxProps) {
    const { icon, title, rightContent, children } = props;
    return <fieldset>
        <div className="title-box">
            <legend>
                <div className='left-content'>
                    <h5>{icon}{title}</h5>
                </div>
                {rightContent && <div className="right-content">{rightContent}</div>}
            </legend>
        </div>
        {children && <div>{children}</div>}
    </fieldset>;
}